import React from 'react'
import { useSelector } from 'hooks/use-redux'
import { getSubscription } from '@disco/state-management/selectors/subscription'
import BillingContactInformation from './BillingContactInformation'
type Props = {
  location: string
}

const BillingContactInformationContainer = ({
  showSections,
  isPlanChange,
  location,
}: {
  showSections?: boolean
  isPlanChange?: boolean
  location?: string
}): React.ReactNode => {
  // subscription loaded in SubscribedUserBillingContainer
  const subscription = useSelector(getSubscription)
  const user = useSelector(state => state.user)

  return (
    <BillingContactInformation
      address={subscription?.address ?? undefined}
      address_2={subscription?.address_2 ?? undefined}
      zip={subscription?.zip ?? undefined}
      city={subscription?.city ?? undefined}
      state={subscription?.state ?? undefined}
      country={subscription?.country ?? undefined}
      email={subscription?.email ?? undefined}
      showSections={showSections}
      isPlanChange={isPlanChange}
      disabledUpdatePaymentDetails={
        !user.permissions?.includes('can_change_business_settings')
      }
      location={location}
    />
  )
}

export default BillingContactInformationContainer
